import React from 'react';
import styles from './Price.module.css';

/** @param {number} price */
const formatPrice = price =>
  price === 0 ? 'Free' : `$${(price / 100).toFixed(2)}`;

/**
 * @param {object} props
 * @param {string=} props.className
 * @param {FF.AWSProduct} props.product
 */
export default function Price({ className = '', product }) {
  const hasDiscount = product.basePrice && product.basePrice !== product.price;

  return (
    <div className={className}>
      {product.price && (
        <span className={hasDiscount ? styles.priceWithDiscount : styles.price}>
          {formatPrice(product.price)}
        </span>
      )}
      {product.basePrice && hasDiscount && (
        <span className={styles.strikethroughPrice}>
          {formatPrice(product.basePrice)}
        </span>
      )}
    </div>
  );
}
